/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bbfrontend": {
        "nested": {
          "service": {
            "nested": {
              "v1": {
                "nested": {
                  "DigitalWalletSnapshot": {
                    "fields": {
                      "apple": {
                        "type": ".squareup.bbfrontend.service.v1.DigitalWalletSnapshot.AppleWallet",
                        "id": 1
                      },
                      "google": {
                        "type": ".squareup.bbfrontend.service.v1.DigitalWalletSnapshot.GoogleWallet",
                        "id": 2
                      }
                    },
                    "nested": {
                      "GoogleWallet": {
                        "fields": {
                          "isGooglePayAvailable": {
                            "type": "bool",
                            "id": 1,
                            "rule": "optional"
                          },
                          "existingTokens": {
                            "type": ".squareup.bbfrontend.service.v1.DigitalWalletSnapshot.GoogleWallet.GooglePayToken",
                            "id": 2,
                            "rule": "repeated"
                          }
                        },
                        "nested": {
                          "GooglePayToken": {
                            "fields": {
                              "fpanLastFour": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "dpanLastFour": {
                                "type": "string",
                                "id": 2,
                                "rule": "optional"
                              },
                              "tokenState": {
                                "type": ".squareup.bbfrontend.service.v1.DigitalWalletSnapshot.GoogleWallet.GooglePayTokenState",
                                "id": 3,
                                "rule": "optional"
                              },
                              "issuerName": {
                                "type": "string",
                                "id": 4,
                                "rule": "optional"
                              },
                              "issuerTokenId": {
                                "type": "string",
                                "id": 5,
                                "rule": "optional"
                              }
                            }
                          },
                          "GooglePayTokenState": {
                            "values": {
                              "GOOGLE_PAY_TOKEN_STATE_DO_NOT_USE": 0,
                              "TOKEN_STATE_UNTOKENIZED": 1,
                              "TOKEN_STATE_PENDING": 2,
                              "TOKEN_STATE_NEEDS_IDENTITY_VERIFICATION": 3,
                              "TOKEN_STATE_SUSPENDED": 4,
                              "TOKEN_STATE_ACTIVE": 5,
                              "TOKEN_STATE_FELICA_PENDING_PROVISIONING": 6
                            }
                          }
                        }
                      },
                      "AppleWallet": {
                        "fields": {
                          "canAddPasses": {
                            "type": "bool",
                            "id": 2,
                            "rule": "optional"
                          },
                          "existingPasses": {
                            "type": ".squareup.bbfrontend.service.v1.DigitalWalletSnapshot.AppleWallet.Pass",
                            "id": 1,
                            "rule": "repeated"
                          },
                          "remoteExistingPasses": {
                            "type": ".squareup.bbfrontend.service.v1.DigitalWalletSnapshot.AppleWallet.Pass",
                            "id": 3,
                            "rule": "repeated"
                          }
                        },
                        "nested": {
                          "Pass": {
                            "fields": {
                              "primaryAccountIdentifier": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "canBeAdded": {
                                "type": "bool",
                                "id": 2,
                                "rule": "optional"
                              },
                              "cardNumberSuffix": {
                                "type": "string",
                                "id": 3,
                                "rule": "optional"
                              },
                              "passTypeIdentifier": {
                                "type": "string",
                                "id": 4,
                                "rule": "optional"
                              },
                              "deviceAccountIdentifier": {
                                "type": "string",
                                "id": 5,
                                "rule": "optional"
                              },
                              "deviceAccountNumberSuffix": {
                                "type": "string",
                                "id": 6,
                                "rule": "optional"
                              },
                              "passActivationState": {
                                "type": ".squareup.bbfrontend.service.v1.DigitalWalletSnapshot.AppleWallet.Pass.ApplePassActivationState",
                                "id": 7,
                                "rule": "optional"
                              },
                              "devicePassIdentifier": {
                                "type": "string",
                                "id": 8,
                                "rule": "optional"
                              },
                              "isRemotePass": {
                                "type": "bool",
                                "id": 9,
                                "rule": "optional"
                              }
                            },
                            "nested": {
                              "ApplePassActivationState": {
                                "values": {
                                  "APPLE_PASS_ACTIVATION_STATE_UNKNOWN": 0,
                                  "APPLE_PASS_ACTIVATION_STATE_ACTIVATED": 1,
                                  "APPLE_PASS_ACTIVATION_STATE_REQUIRES_ACTIVATION": 2,
                                  "APPLE_PASS_ACTIVATION_STATE_ACTIVATING": 3,
                                  "APPLE_PASS_ACTIVATION_STATE_SUSPENDED": 4,
                                  "APPLE_PASS_ACTIVATION_STATE_DEACTIVATED": 5
                                }
                              }
                            }
                          }
                        }
                      },
                      "platform": {
                        "oneof": ["apple", "google"]
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.DigitalWalletSnapshot && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.DigitalWalletSnapshot?.nested?.GoogleWallet && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.DigitalWalletSnapshot?.nested?.GoogleWallet?.nested?.GooglePayToken && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.DigitalWalletSnapshot?.nested?.GoogleWallet?.nested?.GooglePayTokenState && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.DigitalWalletSnapshot?.nested?.AppleWallet && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.DigitalWalletSnapshot?.nested?.AppleWallet?.nested?.Pass && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.DigitalWalletSnapshot?.nested?.AppleWallet?.nested?.Pass?.nested?.ApplePassActivationState) {
  $root.addJSON(jsonData);
}

/**
 * Known cards already added to the client device.
 *
 * Used to determine if the card can be added the the device's digital wallet or paired devices.
 *
 * SOURCE DigitalWalletSnapshot @ squareup/bbfrontend/v1/digital_wallet_snapshot.proto at 13:1
 */
export const DigitalWalletSnapshot = $root.lookupType('squareup.bbfrontend.service.v1.DigitalWalletSnapshot');
fixType(DigitalWalletSnapshot);
Builder.createAndAttachToType(DigitalWalletSnapshot);
/**
 * SOURCE GoogleWallet @ squareup/bbfrontend/v1/digital_wallet_snapshot.proto at 19:3
 */
DigitalWalletSnapshot.GoogleWallet = $root.lookupType('squareup.bbfrontend.service.v1.DigitalWalletSnapshot.GoogleWallet');
fixType(DigitalWalletSnapshot.GoogleWallet, {
  isGooglePayAvailable: {
    required: true
  }
});
Builder.createAndAttachToType(DigitalWalletSnapshot.GoogleWallet);
/**
 * This is a representation of Google's TokenInfo class.
 * https://developers.google.com/pay/issuers/apis/push-provisioning/android/reading-wallet
 *
 * SOURCE GooglePayToken @ squareup/bbfrontend/v1/digital_wallet_snapshot.proto at 34:5
 */
DigitalWalletSnapshot.GoogleWallet.GooglePayToken = $root.lookupType('squareup.bbfrontend.service.v1.DigitalWalletSnapshot.GoogleWallet.GooglePayToken');
fixType(DigitalWalletSnapshot.GoogleWallet.GooglePayToken, {
  fpanLastFour: {
    notEmpty: true
  },
  dpanLastFour: {
    notEmpty: true
  },
  tokenState: {
    required: true
  }
});
Builder.createAndAttachToType(DigitalWalletSnapshot.GoogleWallet.GooglePayToken);
/**
 * The token state of the wallet item on device.
 *
 * SOURCE GooglePayTokenState @ squareup/bbfrontend/v1/digital_wallet_snapshot.proto at 54:5
 */
DigitalWalletSnapshot.GoogleWallet.GooglePayTokenState = $root.lookupEnum('squareup.bbfrontend.service.v1.DigitalWalletSnapshot.GoogleWallet.GooglePayTokenState').values;
/**
 * SOURCE AppleWallet @ squareup/bbfrontend/v1/digital_wallet_snapshot.proto at 77:3
 */
DigitalWalletSnapshot.AppleWallet = $root.lookupType('squareup.bbfrontend.service.v1.DigitalWalletSnapshot.AppleWallet');
fixType(DigitalWalletSnapshot.AppleWallet);
Builder.createAndAttachToType(DigitalWalletSnapshot.AppleWallet);
/**
 * SOURCE Pass @ squareup/bbfrontend/v1/digital_wallet_snapshot.proto at 94:5
 */
DigitalWalletSnapshot.AppleWallet.Pass = $root.lookupType('squareup.bbfrontend.service.v1.DigitalWalletSnapshot.AppleWallet.Pass');
fixType(DigitalWalletSnapshot.AppleWallet.Pass, {
  primaryAccountIdentifier: {
    notEmpty: true
  },
  canBeAdded: {
    required: true
  },
  cardNumberSuffix: {
    notEmpty: true
  },
  passTypeIdentifier: {
    required: true
  },
  passActivationState: {
    required: true
  }
});
Builder.createAndAttachToType(DigitalWalletSnapshot.AppleWallet.Pass);
/**
 * SOURCE ApplePassActivationState @ squareup/bbfrontend/v1/digital_wallet_snapshot.proto at 134:7
 */
DigitalWalletSnapshot.AppleWallet.Pass.ApplePassActivationState = $root.lookupEnum('squareup.bbfrontend.service.v1.DigitalWalletSnapshot.AppleWallet.Pass.ApplePassActivationState').values;